export default "__VITE_ASSET__B1kMH_gu__"